import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderSpinnerState } from './loader-spinner-state';

@Injectable({
  providedIn: 'root'
})
export class LoaderSpinnerService {

  private loaderSpinnerSubject = new Subject<LoaderSpinnerState>();
  loaderSpinnerState = this.loaderSpinnerSubject.asObservable();

  constructor() { }

  show()
  {
    console.log("SHOW SPINNER!");
    this.loaderSpinnerSubject.next(<LoaderSpinnerState>{ show: true });
  }

  hide()
  {
    this.loaderSpinnerSubject.next(<LoaderSpinnerState>{ show: false });
  }
}
